function loginUser(classes?: string, width = '13') {
  return (
    <svg className={`stroke-current fill-current h-auto ${classes}`} viewBox="0 0 13 16" width={width} xmlns="http://www.w3.org/2000/svg">
      <path d="M9.55556 4.11111C9.55556 5.82933 8.16266 7.22222 6.44445 7.22222C4.72623 7.22222 3.33333 5.82933 3.33333 4.11111C3.33333 2.39289 4.72623 1 6.44445 1C8.16266 1 9.55556 2.39289 9.55556 4.11111Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.44444 9.55556C3.43756 9.55556 1 11.9931 1 15H11.8889C11.8889 11.9931 9.45133 9.55556 6.44444 9.55556Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default loginUser